// Does this device prefer reduced motion? Returns `null` server-side.
var prefersReducedMotion={current:null};var hasReducedMotionListener={current:false};export{hasReducedMotionListener,prefersReducedMotion};